export default class FaceApi {
    constructor() {
        this.header = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };
        this.accessKey = process.env.ACCESS_KEY;
    }

    async searchDuplicates(externalId, imgData, collectionIds) {
        const url = `${window.location.origin}/api/face/search-duplicates`;
        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                ...this.header,
                accessKey: this.accessKey
            },
            body: JSON.stringify({ externalId, imgData, collectionIds })
        });
        return await rawResponse.json();
    }

    async addTemporal(collectionId, externalId, imgData) {
        const url = `${window.location.origin}/api/face/add-temporal`;
        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                ...this.header,
                accessKey: this.accessKey
            },
            body: JSON.stringify({ collectionId, externalId, imgData })
        });
        return await rawResponse.json();
    }

    async removeTemporal(collectionId, externalId) {
        const url = `${window.location.origin}/api/face/remove-temporal`;
        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                ...this.header,
                accessKey: this.accessKey
            },
            body: JSON.stringify({ collectionId, externalId })
        });
        return await rawResponse.json();
    }

    async promoteToPermanent(collectionId, externalId) {
        const url = `${window.location.origin}/api/face/promote-to-permanent`;
        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                ...this.header,
                accessKey: this.accessKey
            },
            body: JSON.stringify({ collectionId, externalId })
        });
        return await rawResponse.json();
    }
}
